const compareBoolean = (valueA, valueB) => {
  if (valueA === valueB) return 0;
  else if (valueA === true) return 1;
  else if (valueA === false) return -1;
};

export default compareBoolean;
